module.exports = "<!--<cat-menu-right></cat-menu-right>-->\r\n<!--<cat-menu-left></cat-menu-left>-->\r\n<!--<cat-top-bar></cat-top-bar>-->\r\n<!--<div class=\"cat__content\">-->\r\n<!--<router-outlet></router-outlet>-->\r\n<!--<cat-footer></cat-footer>-->\r\n<!--</div>-->"


//////////////////
// WEBPACK FOOTER
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/structure.html
// module id = ../../../../../src/app/structure/structure.html
// module chunks = main